module.exports = {"id":"dp5_2l1q3","text":"Identifying Needs and Digital Technological Responses","instructions":"Which of the following best describes an assistive technology?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.2","questionType":"PickOne","random":true,"options":[{"id":"dp5_2l1q3-a1","text":"Technology that helps users overcome access barriers","score":1.8},{"id":"dp5_2l1q3-a2","text":"Technology that upgrades device hardware","score":0},{"id":"dp5_2l1q3-a3","text":"Technology that limits software features","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.2/l1q3.json
// module id = 1304
// module chunks = 41